<template>
    <div class="position-relative">
        <router-link to="/users/operations" class="btn btn-outline-secondary" style="position: absolute; left: 0; top: 0;">
            <span class="links_name">Операции</span>
        </router-link>

        <tsoft-table
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="true"
            @show="openUserInfo"
            @edit="openEditUserModal"
            @delete="deleteItem"
        ></tsoft-table>

        <b-sidebar
            v-if="editedItem.id === -1 || editedItem.id > -1"
            id="sidebar-right-edit-user"
            right
            backdrop
            shadow
            width="85%"
            backdrop-variant="dark"
            ref="editItem"
            :title="modalTitle()"
            @hidden="closeSidePanelCallback"
        >
            <div class="d-block">
                <form @submit.prevent="onClickSaveButton" class="mb-4">
                    <div class="form-row user-form">
                        <div class="form-group col-md-12">
                            <label for="lastName">Фамилия</label>
                            <input v-model="lastName" type="text" class="form-control" id="lastName" @input="onCheckFormLastName">
                            <p v-if="errors.lastName" class="error-valid">{{ errors.lastName }}</p>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="firstName">Имя</label>
                            <input v-model="firstName" type="text" class="form-control" id="firstName" @input="onCheckFormName">
                            <p v-if="errors.name" class="error-valid">{{ errors.name }}</p>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="surName">Отчество</label>
                            <input v-model="surName" type="text" class="form-control" id="surName">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="phone">Телефон</label>
                            <input v-mask="`+# (###) ###-##-##`" v-model="maskPhone" type="text" class="form-control" id="phone" @input="onCheckFormPhone">
                            <p v-if="errors.phone" class="error-valid">{{ errors.phone }}</p>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="position">Должность</label>
                            <input v-model="editedItem.position" type="text" class="form-control" id="position">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="email">Email</label>
                            <input v-model="editedItem.email" type="email" class="form-control" id="email" @input="onCheckFormEmail">
                            <p v-if="errors.email" class="error-valid">{{ errors.email }}</p>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="phone">Пароль</label>
                            <input v-model="editedItem.password" type="password" class="form-control" id="password" autocomplete="off" @input="onCheckFormPassword">
                            <p v-if="errors.password" class="error-valid">{{ errors.password }}</p>
                        </div>
                        <div class="form-group col-md-6">
                            <b-form-checkbox 
                                v-model="editedItem.is_operation_director" 
                                type="checkbox"
                                name="check-button"
                                value="1" 
                                unchecked-value="0" 
                                switch 
                            >
                                <b>Операционный директор?</b>
                            </b-form-checkbox>
                        </div>
                        <div class="form-group col-md-6">
                            <b-form-checkbox 
                                v-model="editedItem.fired" 
                                type="checkbox"
                                name="check-button"
                                value="1" 
                                unchecked-value="0" 
                                switch 
                            >
                                <b>Уволен?</b>
                            </b-form-checkbox>
                        </div>
                        <div v-if="!isLeadObserverRole" class="form-group col-md-6">
                            <label>Прошел испытательный срок</label>
                            <b-form-input
                                id="trial_period_ends_at"
                                type="date"
                                v-model="editedItem.trial_period_ends_at"
                            ></b-form-input>
                        </div>

                        <!-- Наблюдатель лидов: источники заказов -->
                        <template v-if="isLeadObserverRole">
                            <div class="form-group col-md-12">
                                <h5 class="mt-3 mb-1">Наблюдатель лидов</h5>
                                <label for="lead_observer_sources">Источники заказов, которые видит наблюдатель</label>
                                <tsoft-select-of-properties
                                    :key="`lead_observer_sources_${refresherLeadObserverSources}`"
                                    :reference_id="4"
                                    :needNullElement="false"
                                    :needMultipleSelect="true"
                                    :defaultSelectName="`Выберите источники`"
                                    :selectedArray="leadObserverAllowedSources"
                                    @set="setLeadObserverAllowedSources"
                                ></tsoft-select-of-properties>
                            </div>
                        </template>
                        
                        <!-- Условия сотрудничества -->
                        <div v-if="shouldShowSalaryField" class="form-group col-md-12">
                            <h5 class="mt-3 mb-1">Условия сотрудничества</h5>
                        </div>
                        <div v-if="shouldShowSalaryField" class="form-group col-md-6">
                            <label for="salary">Зарплата + налоги + офис + другие расходы (руб.)</label>
                            <input 
                                v-model="userSalary" 
                                type="number" 
                                step="0.01"
                                class="form-control" 
                                id="salary"
                                placeholder="200000"
                            >
                        </div>
                        <div class="form-group col-md-12">
                            <label for="role">Роль</label>
                            <b-form-select 
                                v-model="editedItem.role" 
                                :options="rolesList" 
                                multiple 
                                :select-size="10"
                                style="height: 400px !important;" 
                                id="role"
                            ></b-form-select>
                        </div>
                        <template 
                            v-if="editedItem.role.includes('logistics-manager') 
                                  || editedItem.role.includes('logistics-head-manager')"
                        >
                            <div class="form-group col-md-12">
                                <label for="set_segments_transport_company">Транспортные сегменты для сотрудника</label>
                                <tsoft-select-of-properties
                                    :key="`set_segments_transport_company`"
                                    :reference_id="86"
                                    :needNullElement="false"
                                    :needMultipleSelect="true"
                                    :defaultSelectName="``"
                                    :selectedArray="selectedTransportSegments"
                                    @set="setSegmentsOfTransportCompany"
                                ></tsoft-select-of-properties>                            
                            </div>

                            <!-- Динамические селекторы стран для каждого выбранного транспортного сегмента -->
                            <div 
                                v-for="segmentId in selectedTransportSegments" 
                                :key="`segment_countries_${segmentId}`"
                                class="form-group col-md-12"
                            >
                                <label :for="`set_segments_by_countries_${segmentId}`">
                                    Сегменты стран для "{{ getTransportSegmentName(segmentId) }}"
                                </label>
                                <tsoft-select-of-properties
                                    :key="`set_segments_by_countries_${segmentId}_${refreshers[`set_segments_by_countries_${segmentId}`]}`"
                                    :reference_id="20"
                                    :needNullElement="false"
                                    :needMultipleSelect="true"
                                    :defaultSelectName="``"
                                    :selectedArray="getCountriesForSegment(segmentId)"
                                    @set="(countries) => setSegmentsOfCountries(segmentId, countries)"
                                ></tsoft-select-of-properties>  
                                
                                <div class="region-buttons" style="margin-top: 5px;">
                                    <button
                                        v-for="(countries, region) in regions"
                                        :key="region"
                                        class="btn btn-outline-secondary btn-sm mr-1"
                                        @click.prevent="selectRegionCountries(countries, segmentId)"
                                    >
                                        {{ region }}
                                    </button>
                                </div>                                
                            </div>
                        </template>
                    </div>
                    <div class="text-right">
                        <button type="submit" class="btn btn-primary">Сохранить<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></button>
                    </div>
                </form>
            </div>
        </b-sidebar>

        <UserDetails
            :detailedItem="detailedItem"
        />
    </div>
</template>

<script>
import { API_USERS } from '@/constants';

import {
    defaultDataItems,
    actionShowItem,
    actionCreateOrUpdateItem,
    actionDeleteItem,
    constantsUserRoles,
    mixinFIO
} from '@/mixins';

import { regionHelpers } from '@/mixins/regionHelpers';

import UserDetails from '@components/user/UserDetails';

const initialEditedItem = () => ({
    id: '',
    name: '',
    phone: '',
    position: '',
    email: '',
    password: '',
    role: [],       // if we want to set new role
    roles: [],
    fired: 0,
    is_operation_director: 0,
    avatar_path: '',
    trial_period_ends_at: null,
    segments_transport_company: [],
    segments_by_countries: []
})

export default {
    mixins: [
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        constantsUserRoles,
        mixinFIO,
        regionHelpers
    ],
    data() {
        return {
            tableApiUrl: API_USERS,
            fieldFIO: "name",
            maskPhone: "",
            reloadComponent: false,
            errors: {
                name: '',
                lastName: '',
                email: '',
                phone: '',
                password: ''
            },
            segmentCountries: {}, // Объект для хранения стран каждого сегмента: {segmentId: [countryIds]}
            leadObserverAllowedSources: [], // ID источников заказов для роли «Наблюдатель лидов»
            refresherLeadObserverSources: 0
        };
    },
    components: {
        UserDetails
    },
    computed: {
        // Правильная обработка сегментов транспорта для selectedArray
        selectedTransportSegments() {
            if (!this.editedItem.segments_transport_company) return [];
            
            // Если это массив объектов (данные с бэкенда), извлекаем ID
            if (this.editedItem.segments_transport_company.length > 0 && 
                typeof this.editedItem.segments_transport_company[0] === 'object' && 
                this.editedItem.segments_transport_company[0].reference_property_id) {
                return this.editedItem.segments_transport_company.map(item => item.reference_property_id);
            }
            
            // Если это уже массив ID (выбранные пользователем), возвращаем как есть
            return this.editedItem.segments_transport_company;
        },
        
        // Правильная обработка сегментов стран для selectedArray
        selectedCountrySegments() {
            if (!this.editedItem.segments_by_countries) return [];
            
            // Если это массив объектов (данные с бэкенда), извлекаем ID
            if (this.editedItem.segments_by_countries.length > 0 && 
                typeof this.editedItem.segments_by_countries[0] === 'object' && 
                this.editedItem.segments_by_countries[0].id) {
                return this.editedItem.segments_by_countries.map(item => item.id);
            }
            
            // Если это уже массив ID (выбранные пользователем), возвращаем как есть
            return this.editedItem.segments_by_countries;
        },   
            
        // Проверяем, нужно ли показывать поле зарплаты
        shouldShowSalaryField() {
            if (!this.editedItem.role || !Array.isArray(this.editedItem.role)) {
                return false;
            }
            
            // Исключаем роли, для которых не нужна зарплата
            const excludedRoles = ['agent', 'client', 'administrator', 'president', 'lead-observer'];

            // Если у пользователя есть исключенная роль, не показываем поле зарплаты
            return !this.editedItem.role.some(role => excludedRoles.includes(role));
        },

        isLeadObserverRole() {
            return this.editedItem.role && Array.isArray(this.editedItem.role) && this.editedItem.role.includes('lead-observer');
        },

        // Безопасный доступ к зарплате
        userSalary: {
            get() {
                return (this.editedItem.terms_of_cooperation && this.editedItem.terms_of_cooperation.salary) || 0;
            },
            set(value) {
                if (!this.editedItem.terms_of_cooperation) {
                    this.editedItem.terms_of_cooperation = {};
                }
                this.editedItem.terms_of_cooperation.salary = value;
            }
        }
    },
    mounted() {
        this.editedItem = initialEditedItem();
    },
    watch: {
        "maskPhone": function (phone) {
            if (phone) {
                let freshPhone = phone.replace(/[^0-9]/g, "");
                this.editedItem.phone = freshPhone;
            }
        },
        // Следим за изменениями транспортных сегментов чтобы обновить refreshers
        selectedTransportSegments: {
            handler(newSegments, oldSegments) {
                this.initializeRefreshersForSegments(newSegments);
                
                // Удаляем данные о странах для удаленных сегментов
                if (oldSegments) {
                    oldSegments.forEach(segmentId => {
                        if (!newSegments.includes(segmentId)) {
                            this.$delete(this.segmentCountries, segmentId);
                            this.$delete(this.refreshers, `set_segments_by_countries_${segmentId}`);
                        }
                    });
                }
            },
            deep: true
        }
    },
    methods: {
        modalTitle() {
            let title = "Добавление пользователя";
            if (this.editIndex > -1) {
                title = "Пользователь #" + this.editedItem.id;
            }
            return title;
        },
        // calls from mixin on item edit
        onItemEditModalCallback() {
            
            if (this.editedItem.roles.length > 0) {
                this.editedItem.role = [];
                this.editedItem.roles.forEach((item) => {
                    this.editedItem.role.push(item.slug);
                });
            }
            this.maskPhone = this.editedItem.phone;
            this.splitFIO();

            if (this.editedItem.trial_period_ends_at) {
                // Преобразуем дату в формат YYYY-MM-DD, если она в формате d.m.Y
                const parts = this.editedItem.trial_period_ends_at.split('.');
                if (parts.length === 3) {
                    this.editedItem.trial_period_ends_at = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
            }
            
            // Инициализируем данные стран из сегментов
            this.initializeSegmentCountriesFromData();

            // Загружаем разрешённые источники для наблюдателя лидов
            if (this.editedItem.role && this.editedItem.role.includes('lead-observer') && this.editedItem.id) {
                api.call('get', `${API_USERS}/${this.editedItem.id}/lead-observer-sources`)
                    .then(({ data }) => {
                        this.leadObserverAllowedSources = data.reference_sources_id || [];
                        this.refresherLeadObserverSources++;
                    })
                    .catch(() => {
                        this.leadObserverAllowedSources = [];
                    });
            } else {
                this.leadObserverAllowedSources = [];
            }

            // Инициализация условий сотрудничества для пользователей с зарплатой
            if (this.shouldShowSalaryField) {
                // Если данные уже есть с сервера, используем их
                if (this.editedItem.terms_of_cooperation) {
                    // Данные уже загружены с сервера
                } else {
                    // Инициализируем только зарплату по умолчанию
                    this.editedItem.terms_of_cooperation = {
                        salary: 200000
                    };
                }
            }
        },
        
        // Инициализируем данные стран из полученных с бэкенда сегментов
        initializeSegmentCountriesFromData() {
            if (this.editedItem.segments_transport_company && 
                Array.isArray(this.editedItem.segments_transport_company) &&
                this.editedItem.segments_transport_company.length > 0 &&
                typeof this.editedItem.segments_transport_company[0] === 'object' &&
                this.editedItem.segments_transport_company[0].reference_property_id) {
                
                // Данные пришли с бэкенда в формате [{reference_property_id, countries}]
                this.segmentCountries = {};
                this.editedItem.segments_transport_company.forEach(segment => {
                    this.$set(this.segmentCountries, segment.reference_property_id, segment.countries || []);
                });
                
                // Преобразуем в простой массив ID для selectedTransportSegments
                this.editedItem.segments_transport_company = this.editedItem.segments_transport_company.map(
                    segment => segment.reference_property_id
                );
            }
        },
        
        // calls from mixin on item save
        onCreateOrUpdateItemCallback() {
            this.setFIO();
            
            // Подготавливаем данные для отправки на бэкенд в формате [{transport_segment_id, countries}]
            const segmentsWithCountries = this.selectedTransportSegments.map(segmentId => ({
                transport_segment_id: segmentId,
                countries: this.segmentCountries[segmentId] || []
            }));
            
            this.editedItem.segments_transport_company = segmentsWithCountries;
        },
        // calls from mixin on item save
        onCreatedOrUpdatedCallback() {
            this.isSidebarOpen = false;
        },
        // calls from mixin on modal close
        closeSidePanelCallback() {
            this.editedItem = initialEditedItem();
            this.maskPhone = "";
            this.lastName = "";
            this.firstName = "";
            this.surName = "";
            this.errors = {
                name: '',
                lastName: '',
                email: '',
                phone: '',
                password: ''
            };
            this.editIndex = -1;
            this.segmentCountries = {};
            this.refreshers = {};
            this.leadObserverAllowedSources = [];
        },
        setLeadObserverAllowedSources(ids) {
            this.leadObserverAllowedSources = Array.isArray(ids) ? ids : (ids ? [ids] : []);
        },
        /** Сохранить источники наблюдателя лидов для пользователя (если роль выбрана). Возвращает Promise. */
        saveLeadObserverSourcesIfNeeded(userId) {
            if (!this.editedItem.role || !this.editedItem.role.includes('lead-observer')) {
                return Promise.resolve();
            }
            return api.call('put', `${API_USERS}/${userId}/lead-observer-sources`, {
                reference_sources_id: this.leadObserverAllowedSources || []
            }).catch(() => {});
        },
        /** Переопределение: после сохранения пользователя сохраняем источники для роли «Наблюдатель лидов», затем закрываем панель. */
        createOrUpdateItem() {
            this.savingProcess = true;
            if (typeof this.onCreateOrUpdateItemCallback === 'function') {
                this.onCreateOrUpdateItemCallback();
            }
            const finish = (data) => {
                const userId = data.id;
                this.saveLeadObserverSourcesIfNeeded(userId).then(() => {
                    if (typeof this.onCreatedOrUpdatedCallback === 'function') {
                        this.onCreatedOrUpdatedCallback(data);
                    }
                    if (typeof this.updateParentData === 'function') {
                        this.updateParentData();
                    }
                    this.validationErrors = '';
                    this.savingProcess = false;
                    this.closeSidePanelCallback();
                    this.makeToast('success');
                    this.$root.$emit('bv::toggle::collapse', 'sidebar-right-edit-user');
                });
            };
            if (this.editIndex === -1) {
                api.call('post', this.tableApiUrl, this.editedItem).then(({ data }) => {
                    this.items.data.unshift(data);
                    finish(data);
                }).catch((response) => {
                    this.savingProcess = false;
                    if (response && response.status === 422) {
                        this.validationErrors = response.data.error;
                    }
                });
            } else {
                const index = this.editIndex;
                api.call('put', `${this.tableApiUrl}/${this.editedItem.id}`, this.editedItem).then(({ data }) => {
                    Object.assign(this.items.data[index], data);
                    this.editIndex = -1;
                    finish(data);
                }).catch((response) => {
                    this.savingProcess = false;
                    if (response && response.status === 422) {
                        this.validationErrors = response.data.error;
                    }
                });
            }
        },
        openUserInfo(index) {
            let id = this.items.data[index].id;
            api.call('get', `${this.tableApiUrl}/${id}`).then(({data}) => {
                this.detailedItem = data;
                this.$root.$emit('bv::toggle::collapse', 'sidebar-right-user');
            })
        },
        openEditUserModal(index = -1) {
            this.createOrEditItemModal(index);
            setTimeout(() => {
                this.$root.$emit('bv::toggle::collapse', 'sidebar-right-edit-user');
            })
        },
        onClickSaveButton() {
            this.onCheckFormName();
            this.onCheckFormLastName();
            this.onCheckFormEmail();
            this.onCheckFormPhone();
            if (this.editIndex === -1) {
                this.onCheckFormPassword();
            }
            if (!this.errors.name && !this.errors.lastName && !this.errors.email && !this.errors.phone && !this.errors.password) {
                this.createOrUpdateItem();
            }
        },
        onCheckFormName() {
            if (!this.firstName) {
                this.errors.name = 'Введите имя';
            } else if (this.firstName.length <= 2) {
                this.errors.name = 'Имя должно быть больше 2 знаков';
            } else {
                this.errors.name = '';
            }
        },
        onCheckFormLastName() {
            if (!this.lastName) {
                this.errors.lastName = 'Введите фамилию';
            } else {
                this.errors.lastName = '';
            }
        },
        validEmail(email) {
            const res = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return res.test(email);
        },
        onCheckFormEmail() {
            if (!this.editedItem.email) {
                this.errors.email = 'Введите email';
            } else {
                if (!this.validEmail(this.editedItem.email)) {
                    this.errors.email = 'Введите корректный email';
                } else if (this.validEmail(this.editedItem.email)) {
                    this.errors.email = '';
                }
            }
        },
        onCheckFormPhone() {
            if (!this.maskPhone) {
                this.errors.phone = 'Введите номер телефона';
            } else if (this.maskPhone.length != 18) {
                this.errors.phone = 'Введите корректный номер телефона';
            } else {
                this.errors.phone = '';
            }
        },
        onCheckFormPassword() {
            if (!this.editedItem.password) {
                this.errors.password = 'Введите пароль';
            } else {
                this.errors.password = '';
            }
        },
        setSegmentsOfTransportCompany(selectedSegmentIds) {
            this.editedItem.segments_transport_company = selectedSegmentIds;
        },
        setSegmentsOfCountries(segmentId, countries) {
            this.$set(this.segmentCountries, segmentId, countries);
        },
        // Инициализируем refreshers для каждого транспортного сегмента
        initializeRefreshersForSegments(segmentIds) {
            segmentIds.forEach(segmentId => {
                const key = `set_segments_by_countries_${segmentId}`;
                if (!(key in this.refreshers)) {
                    this.$set(this.refreshers, key, 0);
                }
            });
        },
        
        // Получаем название транспортного сегмента по ID из стора
        getTransportSegmentName(segmentId) {
            const groupedProperties = this.$store.getters.GROUPED_REFERENCE_PROPERTIES;
            if (groupedProperties && groupedProperties[86]) {
                const property = groupedProperties[86].find(item => item.id === segmentId);
                return property ? property.name : `Сегмент ${segmentId}`;
            }
            return `Сегмент ${segmentId}`;
        },
        
        // Получаем страны для конкретного сегмента
        getCountriesForSegment(segmentId) {
            return this.segmentCountries[segmentId] || [];
        },
        
        // Обработчик кнопок выбора регионов
        selectRegionCountries(countries, segmentId) {
            this.setSegmentsOfCountries(segmentId, countries);
            // Обновляем refresher для перерисовки компонента
            const key = `set_segments_by_countries_${segmentId}`;
            this.refreshers[key]++;
        },
    },
}

</script>
<style scoped>
  .user-form .error-valid {
    bottom: -47%;
    right: 2%;
    left: auto;
  }
</style>
